export function appendChowNowScript(externalId) {
  const script = document.createElement('script');
  script.src = 'https://cf.chownowcdn.com/latest/static/integrations/ordering-modal.min.js';
  script.setAttribute('data-chownow-company-id', externalId);
  script.setAttribute('class', 'gc-chownow-script');
  window.document.body.appendChild(script);
}
